import { useParams } from 'react-router-dom';
import { useState } from 'react';
import useManageAdminState from '../utils/useManageAdminState';
import { useGetAdminButtons } from '../utils/useGetAdminButtons';
import { useGetRoleChangeButtons } from 'helpers/useGetRoleChangeButtons';
import AdminBasicInfo from './AdminBasicInfo';
import RoleSelectorDisabled from '../../UtilityComponents/Form/RoleSelectorDisabled';
import {
	PageLayout,
	FormSectionHeader,
	RoleChangeButton,
	ChangeRole,
} from 'components';
import { useSelector } from 'react-redux';

export default function ManageAdmin() {
	const { adminId } = useParams();
	const updatedRole = useSelector((state) => state.user.updateRole);
	const { pageTitle, role, disableRoleMessage } = useManageAdminState();

	const [updateRole, setUpdateRole] = useState(false);

	const getBody = () => {
		const reqBody = { id: adminId };
		if (role !== 'admin') {
			reqBody.role = role;
		}
		return reqBody;
	};

	const roleChangeButtons = useGetRoleChangeButtons(adminId, updatedRole);
	const adminButtons = useGetAdminButtons(getBody);

	const buttonArray = updateRole ? roleChangeButtons : adminButtons;

	const handleOnClick = () => {
		setUpdateRole(true);
	};

	return (
		<PageLayout title={pageTitle} buttonArray={buttonArray} align='left'>
			{updateRole ? (
				<ChangeRole id={adminId} />
			) : (
				<>
					<AdminBasicInfo />
					<FormSectionHeader hideTop>Management Options</FormSectionHeader>
					<RoleChangeButton handleOnClick={handleOnClick} />
				</>
			)}
		</PageLayout>
	);
}
